import {ref, watch} from 'vue'
import request from "@/service/request";
import {
    getAddressTree,
    getCityHighColumn,
    getCityHighList, hasPermissionOfDownload,
} from "@/service/api";
let mapTime = localStorage.getItem('mapTime')

export let searchType = ref('high');
export let developer = ref("");
export let checkboxs = ref([]);
export let checkList = ref([]);
export let checkAll = ref(false);
export let tableData = ref([]);

export let total = ref(0)

export let formData = ref({
    quarter: [],
    address: [],
})
export let pagination = ref({
    pageSize: 20,
    pageNum: 1,
})

let column = ref({
    high: [],
    clod: [],
})

watch(pagination, () => {
    getTableData()
}, {immediate: true, deep: true})

let getColumn = async () => {
    let {data: data1} = await request({
        url: getCityHighColumn,
    })

    checkboxs.value = data1
    column.value.high = data1 || []
}


export async function getTableData() {
    const {address} = formData.value
    let params = {
        ...formData.value,
        ...pagination.value,
        provCode: formData.value.provCode,
        cityCode: formData.value.cityCode,
        areaCode: formData.value.areaCode,
        selectedColumns: [...checkList.value],

    }
    delete params.address
    let data= await request({
        url: getCityHighList,
        method: 'post',
        data: {
           ...params
        }
    })
    tableData.value =data.rows || []
    total.value = data.total||0

}


export const changeSearchType = () => {
    searchType.value = 'high';
    checkboxs.value = column.value.high;
    checkAll.value = false;
    checkList.value = [];
    reset()
}

export const handleCheckAllChange = (flag) => {
    checkList.value = flag ? checkboxs.value.map(item => {
        return item.name;
    }) : [];
}

export const handleCheckItemChange = () => {
    checkAll.value = checkList.value.length === checkboxs.value.length;
}

export const reset = () => {
    formData.value = {
        quarter:[],
        address:[]
    }
    pagination.value = {
        pageSize: 20,
        pageNum: 1,
    }
    // getTableData()
}

export const search = () => {
    getTableData()
}

export let headerInfo = ref({
    provinces:[],
    quarter:[]
})
// 获取省市区地址
const getTree = async () => {
    let {data} = await request({
        url: getAddressTree,
        data: {
            filterateaear: false
        }
    })
    headerInfo.value = {
        provinces:data.provinces||[],
        quarter:data.quarter||[]
    }

    // formData['quarter'] = data.quarter[data.quarter.length - 1]
    console.log('55555555555555555555555');
    console.log(data.quarter[data.quarter.length - 1]);
    console.log(formData.value.quarter[0]);
    formData.value.quarter[0] = data.quarter[data.quarter.length - 1]
    console.log('2222222222222222222222222222');
    getTableData();
}

export let permissionOfDownload = ref(false)
const getPermissionOfDownload = async () => {
    let {data} = await request({
        url: hasPermissionOfDownload,
        method: 'get'
    });

    permissionOfDownload.value = data;
}

export const init = () => {
    getPermissionOfDownload()
    getColumn()
    getTree()
}